<template>
    <form @submit.prevent="filterTable">
        <div class="row mt-2">
            <div class="col-12 col-md-6">
                <label class="akkurate-dark small" for="from_date">From Date</label>
                <b-form-group id="from_date" label-for="from_date">
                    <b-form-input class="mt-1 field-container fields" type="date"
                        v-model="form.start_date"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-12 col-md-6 mb-2">
                <label class="akkurate-dark small" for="to_date">To Date</label>
                <b-form-group id="to_date" label-for="to_date">
                    <b-form-input class="mt-1 field-container fields" type="date"
                        v-model="form.end_date"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-12 col-md-6 mb-2">
                <label class="akkurate-dark small" for="branch">Branch</label>
                <multiselect class="mt-1 field-container" v-model="form.branch" :options="form.branch_option"
                    track-by="name" placeholder="Select one" selectLabel="" deselectLabel="" label="name">
                </multiselect>
            </div>
            <div class="col-12 col-md-6 mb-2">
                <label class="akkurate-dark small" for="trans_source">Source</label>
                <multiselect class="field-container mt-1" v-model="form.trans_source" :options="trans_source_options"
                    placeholder="Transaction Source" label="name" selectLabel="" deselectLabel="">
                </multiselect>
            </div>
            <div class="col-12 col-md-6 mb-2">
                <label class="akkurate-dark small" for="trans_source">Ro</label>
                <multiselect class="field-container mt-1" v-model="form.users" :options="users_options" :multiple="true"
                    placeholder="Select Ro" label="name" :custom-label="getUserLabel" selectLabel="" deselectLabel="">
                    <template slot="selection">
                        <span class="multiselect__single" v-if="form.users.length">{{ form.users.length }} options
                            selected</span>
                    </template>
                </multiselect>
                <div class="akkurate-small">{{ getUsers }}</div>
            </div>
        </div>

    </form>

</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components: {
        Multiselect
    },
    props: ['form', 'filterTable', 'trans_source_options', 'users_options'],
    data() {
        return {

        }
    },
    computed: {
        getUsers() {
            if (this.form.users.length > 0) {
                const result = this.form.users.map((index) => {
                    return index.first_name + ' ' + index.surname + ' - ' + index.id;
                });
                // console.log("here");
                return result.join(" | "); // Join array elements with ", "
            } else {
                return "";
            }

        },
    },
    methods:{
        getUserLabel({id,first_name,surname}){
            return `${id} ${first_name} ${surname}`
        }
    }
}

</script>
<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
